<template>
  <div class="container">
    <div class="mb-5">
      <filter-select
        id="accountFilter"
        :selected="form.owner"
        ref="accountFilter"
        :placeholder="$t('common.owner')"
        :multiple="false"
        @filter="onAccountChange"
        @changed="onAccountSelect"
      />

      <sweet-input
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        v-model="form.name"
        type="text"
        layout="vertical"
        inputClass="mb-3"
        :placeholder="$t('workspace.name')"
        class="mt-2"
      />

      <sweet-button :loading="isUpdating" :disabled="isUpdating || $v.$invalid" buttonClass="btn-block mb-2" variant="primary" icon="bx bx-plus" size="sm" @click="save()">
        <span v-if="!form._id"> {{ $t("workspace.create-a-new-workspace") }}</span>
        <span v-else> {{ $t("common.save") }}</span>
      </sweet-button>
    </div>
  </div>
</template>

<script>
import { maxLength, minLength, required } from "vuelidate/lib/validators";

const state = "managementWorkspace";
export default {
  components: {},

  data() {
    return {
      editMode: false,
      title: undefined,
      form: { name: undefined, _id: undefined },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(30),
      },
      owner: {
        required,
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.editedEntity };
      },
    },
  },
  methods: {
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/save`, { workspace: this.form });

        this.title = this.form.name;

        this.$store.commit(`${state}/editedEntity`, null);
        this.$root.$emit("bv::toggle::collapse", "sidebar-workspace-edit");
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    anyError(e) {
      this.formError = e;
    },
    onAccountSelect(item) {
      if (item) {
        this.form.owner = item;
      } else {
        this.form.owner = undefined;
      }
    },
    async onAccountChange(value, callback) {
      const response = await this.$store.dispatch(`managementAccount/paginate`, {
        options: { limit: 20 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
  },
};
</script>
